import { AppDialogModule } from './../../shared/components/dialog/dialog.component';
import { Component, OnInit } from '@angular/core';
import { CrudService } from 'app/shared/services/crud.service';
import { DataTableBasicComponent } from 'app/shared/components/data-table/data-table-basic.component';
import { AuthFeatureUrl } from 'app/proof/model/auth-feature-url.model';
import { Message, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { HttpService } from 'app/shared/services/http.service';
import { SessionService } from 'app/shared/services/session.service';
import { DblinkedSessionService } from 'app/shared/services/dblinked-session.service';
import { ConfigService } from 'app/shared/services/config.service';
import { UtilService } from 'app/shared/services/util.service';
import { Empresa } from 'app/cadastro/model/empresa.model';
import { SelectItem } from 'app/shared/common/select-item.interface';
import { Toolbar } from 'app/shared/model/toolbar.model';
import { ToolbarService } from 'app/shared/services/toolbar.service';

@Component({
  selector: 'app-feature-url',
  templateUrl: './feature-url.component.html',
  styleUrls: ['./feature-url.component.scss'],
  providers: [CrudService]
})
export class AuthFeatureUrlComponent extends DataTableBasicComponent implements OnInit {
  public authFeatureUrl: AuthFeatureUrl = new AuthFeatureUrl();
  public registroFeature: Array<AuthFeatureUrl> = new Array();

  ids: Array<any> = new Array();

  //Boolean
  ctrlSave: boolean;
  editarConta: boolean;
  novaConta: boolean;
  leitura: boolean = false;
  alteracao: boolean = false;
  inclusao: boolean = false;
  exclusao: boolean = false;
  ativa: boolean = false;


  //String
  aplicacao: string;
  funcionalidade: string;

  //Any
  url: any;
  
  
  //Select
  opcoesLeitura: SelectItem[] =  [{label: 'Todos', value: ''}, { label: 'SIm', value: true }, { label: 'Não', value: false }];
  opcoesAlteracao: SelectItem[] =  [{label: 'Todos', value: ''}, { label: 'SIm', value: true }, { label: 'Não', value: false }];
  opcoesAplicacoes: SelectItem[] =  [{label: 'Todos', value: ''}, { label: 'SIm', value: true }, { label: 'Não', value: false }];
  opcoesInclusao: SelectItem[] =  [{label: 'Todos', value: ''}, { label: 'SIm', value: true }, { label: 'Não', value: false }];
  opcoesExclusao: SelectItem[] =  [{label: 'Todos', value: ''}, { label: 'SIm', value: true }, { label: 'Não', value: false }];
  opcoesAtiva: SelectItem[] =  [{label: 'Todos', value: ''}, { label: 'SIm', value: true }, { label: 'Não', value: false }];
  opcoesAplicacao: SelectItem[];
  opcoesFuncionalidades: SelectItem[];
  opcoesFuncionalidadesContabil: SelectItem[];
  opcoesFuncionalidadesAuditorDigital: SelectItem[];
  opcoesFuncionalidadesCentralDoc: SelectItem[];
  opcoesFiltrarAplicacao: SelectItem[];
  opcoesFiltrarFuncionalidades: SelectItem[];
  
 
  msgs: Message[];
 
  title = 'PERMISSÕES';
  subtitle = "PERMISSÃO";
  
  private sessionSubscription: Subscription;
  private beforeSaveSubscription: Subscription;
  private beforeViewSubscription: Subscription;
  private beforeEditSubscription: Subscription;

  constructor(private crudService: CrudService,
    private httpService: HttpService,
    private sessionService: SessionService,
    private toolbarService: ToolbarService,
    private dblinkedSessionService: DblinkedSessionService,
    private messageService: MessageService,
    private utilService: UtilService,
    private configService: ConfigService,
    ) {
    super(crudService);
  }

  public toolbarMain = new Toolbar()

  toolbarMainIni = [
    { icon: 'navigate_before', text: 'Voltar', tooltip: 'Voltar', visible: false, disabled: false, color: 'default', onClick: () => this.carregar() },
    { icon: 'edit', text: 'Editar', tooltip: 'Editar', visible: false, disabled: false, color: 'default', onClick: () => this.loadEditarRegistro() },
    { icon: 'delete', text: 'Remover', tooltip: 'Remover', visible: false, disabled: false, color: 'default', onClick: () => this.excluirRegistro() },
    { icon: 'add', text: 'Novo', tooltip: 'Novo', visible: false, disabled: false, color: 'default', onClick: () => this.criarNovo() },
    { icon: 'save', text: 'Salvar', tooltip: 'Salvar Novo Registro', visible: false, disabled: false, color: 'default', onClick: () => this.salvarNovoRegistro() },
    { icon: 'save', text: 'Salvar', tooltip: 'Salvar Alteração de Registro', visible: false, disabled: false, color: 'default', onClick: () => this.salvarAlteracaoRegistro() },
  ]



  ngOnInit() {
    // TODO: REVIEW (IMPORTANT!)
    this.toolbarMain.setAll(this.toolbarMainIni)
    this.toolbarService.hidden = true
    this.sessionSubscription = this.sessionService.initSubscribe(
      this.dblinkedSessionService.sessionChanged,
      () => this.carregar()
    );
  }

  list: Array<number> = new Array();


  // Selecionar Checkbox
  selectCheckboxContainer(data){
    setTimeout(() => {
      document.getElementById('checkboxContainer'+data.id).click();
    },100);
  };

 
  carregar() {
    this.loadFuncionalidades();
    this.loadFiltrarAplicacao();
    this.loadFiltrarFuncionalidades();
    this.loadItems();
    this.title = 'PERMISSÕES';
    this.subtitle = 'PERMISSÃO';
    this.novaConta = false;
    this.editarConta = false;
    this.ids = new Array();
    this.limpaCamposForm();
    this.loadRegistros();

    this.toolbarMain.setVisible('btn1', false)
    this.toolbarMain.setVisible('btn2', false)
    this.toolbarMain.setVisible('btn3', false)
    this.toolbarMain.setVisible('btn4', true)
    this.toolbarMain.setVisible('btn5', false)
    this.toolbarMain.setVisible('btn6', false)
  }

  criarNovo() {
    this.loadFuncionalidades();
    this.loadFuncionalidadesContabil();
    this.loadFuncionalidadesAuditorDigital();
    this.loadFuncionalidadesCentralDoc();
    this.loadFuncionalidadesEFDFiscal();
    this.loadFuncionalidadesProof();
    this.loadFuncionalidadesSisco();
    this.loadFuncionalidadesXml();
    this.loadFuncionalidadesDblinked();
    this.loadItems();
    this.novaConta = true;
    this.title = 'CADASTRAR PERMISSÕES';

    this.toolbarMain.setVisible('btn1', true)
    this.toolbarMain.setVisible('btn2', false)
    this.toolbarMain.setVisible('btn3', false)
    this.toolbarMain.setVisible('btn4', false)
    this.toolbarMain.setVisible('btn5', true)
    this.toolbarMain.setVisible('btn6', false)
  }

  loadItems() {
    this.opcoesAplicacao = [];
    this.opcoesAplicacao.push({label: 'Selecione', value: 0 });
    this.httpService.get(`authapp?$select=id,name&$orderby=name`, null, 'proof')
      .subscribe(ref => {
        ref.value.forEach(element => {
          this.opcoesAplicacao.push({
            label: element.name,
            value: element.id
          });
        });
      }, error => this.httpService.handleError(error, () => this.httpService.done()));
  }

  loadFuncionalidades() {
    this.opcoesFuncionalidades = [];
    this.opcoesFuncionalidades.push({label: 'Selecione', value: 0 });
    this.httpService.get(`authfeature?$filter=authApp/id%20eq%2020&$orderby=name&$select=id,name`, null, 'proof')
      .subscribe(ref => {
        ref.value.forEach(element => {
          this.opcoesFuncionalidades.push({
            label: element.name,
            value: element.id
          });
        });
      }, error => this.httpService.handleError(error, () => this.httpService.done()));
  }

  loadFuncionalidadesContabil() {
    this.opcoesFuncionalidades = [];
    this.opcoesFuncionalidades.push({label: 'Selecione', value: 0 });
    this.httpService.get(`authfeature?$filter=authApp/id%20eq%2019&$orderby=name&$select=id,name`, null, 'proof')
      .subscribe(ref => {
        ref.value.forEach(element => {
          this.opcoesFuncionalidades.push({
            label: element.name,
            value: element.id
          });
        });
      }, error => this.httpService.handleError(error, () => this.httpService.done()));
  }

  loadFuncionalidadesAuditorDigital() {
    this.opcoesFuncionalidades = [];
    this.opcoesFuncionalidades.push({label: 'Selecione', value: 0 });
    this.httpService.get(`authfeature?$filter=authApp/id%20eq%2018&$orderby=name&$select=id,name`, null, 'proof')
      .subscribe(ref => {
        ref.value.forEach(element => {
          this.opcoesFuncionalidades.push({
            label: element.name,
            value: element.id
          });
        });
      }, error => this.httpService.handleError(error, () => this.httpService.done()));
  }

  loadFuncionalidadesCentralDoc() {
    this.opcoesFuncionalidades = [];
    this.opcoesFuncionalidades.push({label: 'Selecione', value: 0 });
    this.httpService.get(`authfeature?$filter=authApp/id%20eq%202&$orderby=name&$select=id,name`, null, 'proof')
      .subscribe(ref => {
        ref.value.forEach(element => {
          this.opcoesFuncionalidades.push({
            label: element.name,
            value: element.id
          });
        });
      }, error => this.httpService.handleError(error, () => this.httpService.done()));
  }

  loadFuncionalidadesEFDFiscal() {
    this.opcoesFuncionalidades = [];
    this.opcoesFuncionalidades.push({label: 'Selecione', value: 0 });
    this.httpService.get(`authfeature?$filter=authApp/id%20eq%205&$orderby=name&$select=id,name`, null, 'proof')
      .subscribe(ref => {
        ref.value.forEach(element => {
          this.opcoesFuncionalidades.push({
            label: element.name,
            value: element.id
          });
        });
      }, error => this.httpService.handleError(error, () => this.httpService.done()));
  }

  loadFuncionalidadesProof() {
    this.opcoesFuncionalidades = [];
    this.opcoesFuncionalidades.push({label: 'Selecione', value: 0 });
    this.httpService.get(`authfeature?$filter=authApp/id%20eq%2010&$orderby=name&$select=id,name`, null, 'proof')
      .subscribe(ref => {
        ref.value.forEach(element => {
          this.opcoesFuncionalidades.push({
            label: element.name,
            value: element.id
          });
        });
      }, error => this.httpService.handleError(error, () => this.httpService.done()));
  }

  loadFuncionalidadesSisco() {
    this.opcoesFuncionalidades = [];
    this.opcoesFuncionalidades.push({label: 'Selecione', value: 0 });
    this.httpService.get(`authfeature?$filter=authApp/id%20eq%2016&$orderby=name&$select=id,name`, null, 'proof')
      .subscribe(ref => {
        ref.value.forEach(element => {
          this.opcoesFuncionalidades.push({
            label: element.name,
            value: element.id
          });
        });
      }, error => this.httpService.handleError(error, () => this.httpService.done()));
  }

  loadFuncionalidadesXml() {
    this.opcoesFuncionalidades = [];
    this.opcoesFuncionalidades.push({label: 'Selecione', value: 0 });
    this.httpService.get(`authfeature?$filter=authApp/id%20eq%2017&$orderby=name&$select=id,name`, null, 'proof')
      .subscribe(ref => {
        ref.value.forEach(element => {
          this.opcoesFuncionalidades.push({
            label: element.name,
            value: element.id
          });
        });
      }, error => this.httpService.handleError(error, () => this.httpService.done()));
  }

  loadFuncionalidadesDblinked() {
    this.opcoesFuncionalidades = [];
    this.opcoesFuncionalidades.push({label: 'Selecione', value: 0 });
    this.httpService.get(`authfeature?$filter=authApp/id%20eq%2015&$orderby=name&$select=id,name`, null, 'proof')
      .subscribe(ref => {
        ref.value.forEach(element => {
          this.opcoesFuncionalidades.push({
            label: element.name,
            value: element.id
          });
        });
      }, error => this.httpService.handleError(error, () => this.httpService.done()));
  }

  loadFiltrarAplicacao() {
    this.opcoesFiltrarAplicacao = [];
    this.opcoesFiltrarAplicacao.push({label: 'Selecione', value: null },{label: 'Todas', value: null });
    this.httpService.get(`authapp?$select=id,name&$orderby=name`, null, 'proof')
      .subscribe(ref => {
        ref.value.forEach(element => {
          this.opcoesFiltrarAplicacao.push({
            label: element.name,
            value: element.id
          });
        });
      }, error => this.httpService.handleError(error, () => this.httpService.done()));
  }
  loadFiltrarFuncionalidades() {
    this.opcoesFiltrarFuncionalidades = [];
    this.opcoesFiltrarFuncionalidades.push({label: 'Selecione', value: null },{label: 'Todas', value: null });
    this.httpService.get(`authfeature?$select=id,name&$orderby=name`, null, 'proof')
      .subscribe(ref => {
        ref.value.forEach(element => {
          this.opcoesFiltrarFuncionalidades.push({
            label: element.name,
            value: element.id
          });
        });
      }, error => this.httpService.handleError(error, () => this.httpService.done()));
  }

  loadRegistros() {
    this.httpService
      .get(`/authfeatureurl?$select=authFeature/authApp/id,authFeature/authApp/name,authFeature/id,authFeature/name,path,allowGet,allowPut,allowPost,allowDelete,active&$count=true&$skip=0&$orderby=authFeature/authApp/name,authFeature/name,path`, null, 'proof')
      .subscribe(
        (retorno) => {
          this.registroFeature = new Array();
          retorno.value.forEach(item => {
            this.registroFeature.push({
              ...item,
            });
          })
        },
        error => this.httpService.handleError(error, () => this.carregar()),
        () => this.httpService.done()
      );
  }

  loadEditarRegistro() {
    this.loadFuncionalidades();
    this.loadFuncionalidadesContabil();
    this.loadFuncionalidadesAuditorDigital();
    this.loadFuncionalidadesCentralDoc();
    this.loadFuncionalidadesEFDFiscal();
    this.loadFuncionalidadesProof();
    this.loadFuncionalidadesSisco();
    this.loadFuncionalidadesXml();
    this.loadFuncionalidadesDblinked();
    this.loadItems();
    this.title = 'EDITAR PERMISSÕES';
    this.editarConta = true;

    this.toolbarMain.setVisible('btn1', true)
    this.toolbarMain.setVisible('btn2', false)
    this.toolbarMain.setVisible('btn3', true)
    this.toolbarMain.setVisible('btn4', false)
    this.toolbarMain.setVisible('btn5', false)
    this.toolbarMain.setVisible('btn6', true)
    
    this.limpaCamposForm();
    this.httpService.wait()
    this.httpService.get(`/authfeatureurl(${this.ids[0]})?$select=authFeature/authApp/id,authFeature/authApp/name,authFeature/id,authFeature/name,path,allowGet,allowPut,allowPost,allowDelete,active&$count=true,`, null, 'proof')
      .subscribe(plano => {
        this.aplicacao = plano.value.authFeature.authApp.id;
        this.url = plano.value.path;
        this.leitura = plano.value.allowGet;
        this.alteracao = plano.value.allowPut;
        this.inclusao = plano.value.allowPost;
        this.exclusao = plano.value.allowDelete;
        this.ativa = plano.value.active;
      },
        error => this.httpService.handleError(error, () => this.carregar()),
        () => this.httpService.done());

    this.httpService.wait()
    this.httpService.get(`/authfeatureurl(${this.ids[0]})?$select=authFeature/authApp/id,authFeature/authApp/name,authFeature/id,authFeature/name,path,allowGet,allowPut,allowPost,allowDelete,active&$count=true,`, null, 'proof')
      .subscribe(plano => {
        this.funcionalidade = plano.value.authFeature.id;
      },
        error => this.httpService.handleError(error, () => this.carregar()),
        () => this.httpService.done());
  }

  salvarNovoRegistro() {
    if (this.validacao()) {
      return;
    }

    const jsonData = {
      authApp: {id: this.aplicacao},
      authFeature: {id: this.funcionalidade},
      path: this.url,
      allowGet: this.leitura,
      allowPut: this.alteracao,
      allowPost: this.inclusao,
      allowDelete: this.exclusao,
      active: this.ativa,
    };

    this.httpService.wait();
    this.httpService.post('/authfeatureurl', jsonData, 'proof')
      .subscribe(result => {

        if (!(result === null || result === undefined)) {
          this.messageService.add({
            severity: 'success', key: 'messageLinnks', summary: 'Sucesso  ', detail: 'Projeto cadastrado com sucesso!'
          });
          this.carregar();
        } else {
          this.messageService.add({
            severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Falha no cadastro. Tente novamente'
          });
          this.carregar();
          return;
        }
      }, error => this.httpService.handleError(error, () => this.salvarNovoRegistro()),
        () => this.httpService.done());
  }

  salvarAlteracaoRegistro() {
    if (this.validacao()) {
      return;
    }

    const listasEnviar = {
      id: this.ids[0],
      authApp: {id: this.aplicacao},
      authFeature: {id: this.funcionalidade},
      path: this.url,
      allowGet: this.leitura,
      allowPut: this.alteracao,
      allowPost: this.inclusao,
      allowDelete: this.exclusao,
      active: this.ativa,
    };

    let key = this.ids[0];

    this.httpService.wait();
    this.httpService.patch('/authfeatureurl', key, listasEnviar, 'proof')
      .subscribe(result => {
        if (result === null) {
          this.messageService.add({
            severity: 'success', key: 'messageLinnks', summary: 'Sucesso  ', detail: 'Projeto alterado com sucesso!'
          });
          this.carregar();
        } else {
          this.messageService.add({
            severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Falha na alteração do projeto!'
          });
          this.carregar();
          return;
        }
      },
        error => this.httpService.handleError(error, () => this.salvarAlteracaoRegistro()),
        () => this.httpService.done());
  }

  excluirRegistro() {
    if (confirm('Deseja deletar os registros selecionados? ')) {
      const listasEnviar = {
        idsContaContabil: this.ids,
      };
      this.httpService.wait();
      this.httpService.delete('/authfeatureurl', this.ids, 'proof')
        .subscribe(result => {
          if (result === null) {
            this.messageService.add({
              severity: 'success', key: 'messageLinnks',
              summary: '',
              detail: 'Projeto excluído com sucesso!'
            });
            this.carregar();
            this.ids = [];
          
          } else {
            this.messageService.add({
              severity: 'warn', key: 'messageLinnks',
              summary: '',
              detail: 'Falha na exclusão. Tente novamente!'
            });
          }
        },
          error => this.httpService.handleError(error, () => this.carregar()),
          () => this.httpService.done());
    }
  }

  selectCheckbox(event: any) {
    this.ids.push(event.data.id);
    event.selected = false;
    this.changeToolbar()
  }

  unselectCheckbox(event: any) {
    const index = this.ids.findIndex(c => c === event.data.id);
    this.ids.splice(index, 1);
    event.selected = true;
    this.changeToolbarUn()
  }

  changeToolbar() {
    this.toolbarMain.setVisible('btn2', true)
    this.toolbarMain.setVisible('btn3', true)
  }
  changeToolbarUn(){
    this.toolbarMain.setVisible('btn2', false)
    this.toolbarMain.setVisible('btn3', false)
  }

  validacao(): boolean {
    if ((this.aplicacao === null || this.aplicacao === undefined) || this.aplicacao.length < 1) {
      this.messageService.add({ severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Aplicação é Obrigatória' });
      return true;
    }
    if ((this.funcionalidade === null || this.funcionalidade === undefined) || this.funcionalidade.length < 1) {
      this.messageService.add({ severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'Funcionalidade é Obrigatória' });
      return true;
    } 
    if ((this.url === null || this.url === undefined) || this.url.length < 1) {
      this.messageService.add({ severity: 'warn', key: 'messageLinnks', summary: 'Advertência', detail: 'URL é Obrigatória' });
      return true;
    } 
    return false;
  }

  private limpaCamposForm() {
    this.aplicacao = null;
    this.funcionalidade = null;
    this.url = '';
    this.leitura = false;
    this.alteracao = false;
    this.inclusao = false;
    this.exclusao = false;
    this.ativa = false;
    
  }

  ngOnDestroy() {
    // TODO: REVIEW (IMPORTANT!)
    this.sessionSubscription.remove(this.sessionSubscription);
    this.sessionService.destroySubscribe(this.sessionSubscription);
  }
  get hasEmpresaSelected(): boolean {
    return this.dblinkedSessionService.hasEmpresaSelected;
  }
  get loading(): boolean {
    return this.httpService.loading;
  }
  get rowsPerPage() {
    return this.configService.applicationConfig.rowsPerPage;
  }
  get rows() {
    return this.configService.applicationConfig.rows;
  }
  get pageLinks() {
    return this.configService.applicationConfig.pageLinks;
  }
  get empresa(): Empresa {
    return this.dblinkedSessionService.empresa && this.dblinkedSessionService.empresa.id ? this.dblinkedSessionService.empresa : null;
  }
}


